export default __webpack_public_path__ + "static/media/intro_01.8106c76f.png";